import React, { useEffect } from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { CrossClientResultDetails } from './CrossClientResultDetails'
import { CrossClientQueryLogicalQuestionDecomposition } from '../../../../models/CrossClient'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientClients, selectCrossClientClientsLoading, selectCrossClientResultsExecution } from '../../../../store/crossClient/crossClientResults'
import { CrossClientQueryResultDetails } from './hooks'
import { TrackEvent, useTracking } from '../../../../apps/professional-app/fa/common/tracking'

export interface CrossClientResultDetailsModalProps {
  resultDetails: CrossClientQueryResultDetails
  decomposition: CrossClientQueryLogicalQuestionDecomposition
}
export const CrossClientResultDetailsModal: React.FC<CrossClientResultDetailsModalProps> = ({ resultDetails, decomposition }) => {
  const clients = useAppSelector(selectCrossClientClients)
  const clientsLoading = useAppSelector(selectCrossClientClientsLoading)

  const execution = useAppSelector(selectCrossClientResultsExecution)
  const { trackingClient } = useTracking()

  const { selectedResult, selectionSource, handleClearSelectedResult } = resultDetails

  const selectedResultClient = selectedResult ? clients[selectedResult.clientId] : null

  useEffect(() => {
    if (!selectedResult) {
      return
    }
    trackingClient.track({
      eventName: TrackEvent.X_CLIENT_QUERY_VIEW_MATCH,
      eventDetails: {
        executionId: execution?.id,
        clientId: selectedResult.clientId,
        source: selectionSource,
      },
    })
  }, [selectedResult, selectionSource, execution?.id, trackingClient])

  return (
    <Modal
      size='lg'
      show={!!selectedResult}
      header={<h4 className='p-2'>Match details</h4>}
      body={
        clientsLoading && !selectedResultClient ? (
          <div className='skeleton w-100 zocks-mb-2' style={{ height: '300px' }} />
        ) : selectedResult && selectedResultClient ? (
          <CrossClientResultDetails client={selectedResultClient} resultDetails={resultDetails} decomposition={decomposition} />
        ) : null
      }
      onHide={handleClearSelectedResult}
      showFooterActions={false}
    />
  )
}
